var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnLoginPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0004 3.60002C10.1226 3.60002 8.60039 5.12226 8.60039 7.00002V10H15.4004V7.00002C15.4004 5.12226 13.8782 3.60002 12.0004 3.60002ZM7.40039 7.00002V10H7C5.89543 10 5 10.8954 5 12V20C5 21.1046 5.89543 22 7 22H17C18.1046 22 19 21.1046 19 20V12C19 10.8954 18.1046 10 17 10H16.6004V7.00002C16.6004 4.45951 14.5409 2.40002 12.0004 2.40002C9.45988 2.40002 7.40039 4.45951 7.40039 7.00002ZM17 11.2H7C6.55817 11.2 6.2 11.5582 6.2 12V20C6.2 20.4418 6.55817 20.8 7 20.8H17C17.4418 20.8 17.8 20.4418 17.8 20V12C17.8 11.5582 17.4418 11.2 17 11.2ZM13.9996 16.6C14.331 16.6 14.5996 16.3314 14.5996 16C14.5996 15.6687 14.331 15.4 13.9996 15.4H9.99961C9.66824 15.4 9.39961 15.6687 9.39961 16C9.39961 16.3314 9.66824 16.6 9.99961 16.6H13.9996Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnLoginPassword);
export default __webpack_public_path__ + "static/media/icn_login_password.665298c2.svg";
export { ForwardRef as ReactComponent };